import React, { useState } from 'react'
import {
  AppBar,
  Box,
  Dialog,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography
} from '@mui/material'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import CloseIcon from '@mui/icons-material/Close'
import FlowViewer from '../FlowViewer/FlowViewer'

// Lets a business user browse every flow this org has, independent of any customer's session history -
// useful when you want to check what a flow currently looks like without first finding a session that
// happened to visit it. Clicking a flow opens the same read-only editor canvas embed as SessionsList's
// flow chips.
export default function FlowsList({ flows, flowsLoading }) {
  const [selectedFlow, setSelectedFlow] = useState(null)

  if (flowsLoading) {
    return <Typography variant="body2">Loading flows…</Typography>
  }
  if (!flows || flows.length === 0) {
    return <Typography variant="body2">No flows found.</Typography>
  }

  return (
    <Box>
      <List dense>
        {flows.map(f => (
          <ListItemButton key={f.uuid} onClick={() => setSelectedFlow(f)}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <AccountTreeOutlinedIcon sx={{ color: '#6B7280' }} />
            </ListItemIcon>
            <ListItemText primary={f.name} />
          </ListItemButton>
        ))}
      </List>

      <Dialog
        fullScreen
        open={!!selectedFlow}
        onClose={() => setSelectedFlow(null)}
      >
        <AppBar position="relative" color="default">
          <Toolbar>
            <IconButton
              edge="start"
              onClick={() => setSelectedFlow(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" sx={{ marginLeft: 2 }}>
              {selectedFlow ? selectedFlow.name : ''} (view only)
            </Typography>
          </Toolbar>
        </AppBar>
        {selectedFlow && <FlowViewer flowUuid={selectedFlow.uuid} />}
      </Dialog>
    </Box>
  )
}
